import { all } from 'redux-saga/effects';
import session from '@/store/session/sagas';
import user from '@/store/user/sagas';

export default function* rootSaga() {
  yield all([session(), user()]);
}
